
// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";
// import { fetchPressReleases } from "../News/pressReleaseApi.js";
// import { fetchPressCoverages } from "../News/pressCoverageApi.js";

// /* ───────────────────────────────────────────────────────────
//    LEADERSHIP INSIGHTS – static data (same as before)
//    ──────────────────────────────────────────────────────────── */
// const LEADERSHIP_INSIGHTS = [
//   {
//     id: 1,
//     image:
//       "https://www.assocham.org/assets/images/1778233193-1753774173_Nirmal%20Kumar%20Minda.jpg",
//     text: "Budget 2026–27 reflects a constructive policy dialogue between government and industry. It strikes a fine balance between fiscal prudence and growth-oriented reforms.",
//     name: "Nirmal Kumar Minda",
//     designation: "President, ASSOCHAM",
//   },
//   {
//     id: 2,
//     image:
//       "https://www.assocham.org/assets/images/1778232804-1753774173_Nirmal%20Kumar%20Minda.jpg",
//     text: "The four Labour Codes introduce progressive measures that bring India closer to global best practices while ensuring ease of doing business and worker welfare.",
//     name: "Nirmal Kumar Minda",
//     designation: "President, ASSOCHAM",
//   },
//   {
//     id: 3,
//     image:
//       "https://www.assocham.org/assets/images/1778228544-1774255562_SG.jpg",
//     text: "More women lawmakers can make politics fairer and more representative. Their lived experiences bring unique perspectives that strengthen democratic institutions.",
//     name: "Saurabh Sanyal",
//     designation: "Secretary General, ASSOCHAM",
//   },
//   {
//     id: 4,
//     image:
//       "https://www.assocham.org/assets/images/1778232989-1723269254-Sanjay%20Nayar.jpg",
//     text: "Over the past decade, India's startup ecosystem has undergone a fundamental transformation. Today, it stands as a beacon of innovation and entrepreneurship.",
//     name: "Sanjay Nayar",
//     designation: "Immediate Past President, ASSOCHAM",
//   },
// ];

// /* ───────────────────────────────────────────────────────────
//    COMPONENT
//    ──────────────────────────────────────────────────────────── */
// export default function MediaSocialSection() {
//   // ── Tabs & Social ─────────────────────────────────────────
//   const [activeTab, setActiveTab] = useState("releases");
//   const [activeSocial, setActiveSocial] = useState("facebook");

//   // ── Leadership Insights carousel ──────────────────────────
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isHovering, setIsHovering] = useState(false);

//   // ── Press section hover (scroll pause) ────────────────────
//   const [isPressHovering, setIsPressHovering] = useState(false);

//   // ── Backend data ──────────────────────────────────────────
//   const [pressReleases, setPressReleases] = useState([]);
//   const [pressCoverage, setPressCoverage] = useState([]);

//   const navigate = useNavigate();

//   /* ── Fetch 20 press releases + 20 press coverages ──────── */
//   useEffect(() => {
//     let alive = true;

//     fetchPressReleases()
//       .then((data) => {
//         if (!alive) return;
//         const mapped = data.slice(0, 20).map((pr) => ({
//           title: pr.title,
//           date: pr.displayDate,
//           slug: pr.slug,
//         }));
//         setPressReleases(mapped);
//       })
//       .catch((err) => console.error("Press releases fetch failed:", err));

//     fetchPressCoverages()
//       .then((data) => {
//         if (!alive) return;
//         const mapped = data.slice(0, 20).map((pc) => ({
//           title: pc.title,
//           date: pc.displayDate,
//           source: pc.source || "",
//           externalUrl: pc.externalUrl || "",
//         }));
//         setPressCoverage(mapped);
//       })
//       .catch((err) => console.error("Press coverage fetch failed:", err));

//     return () => {
//       alive = false;
//     };
//   }, []);

//   /* ── Active tab ke liye list ────────────────────────────── */
//   const currentList =
//     activeTab === "releases" ? pressReleases : pressCoverage;
//   const loopedList = [
//     ...currentList,
//     ...currentList,
//     ...currentList,
//     ...currentList,
//   ];

//   const currentInsight = LEADERSHIP_INSIGHTS[currentIndex];

//   /* ── Click handler ──────────────────────────────────────── */
//   const handleItemClick = (item) => {
//     if (activeTab === "releases") {
//       if (item.slug) {
//         navigate(`/press-release/${item.slug}`);
//       }
//     } else {
//       if (item.externalUrl) {
//         window.open(item.externalUrl, "_blank", "noopener,noreferrer");
//       }
//     }
//   };

//   /* ── Auto rotate Leadership Insights (hover pe rukega) ── */
//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (!isHovering) {
//         setCurrentIndex(
//           (prev) => (prev + 1) % LEADERSHIP_INSIGHTS.length
//         );
//       }
//     }, 8000); // slowed from 5000ms → 8000ms
//     return () => clearInterval(interval);
//   }, [isHovering]);

//   /* ── Social embeds sirf ek baar load karo ──────────────── */
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (window.twttr) window.twttr.widgets.load();
//       if (window.instgrm) window.instgrm.Embeds.process();
//     }, 800);
//     return () => clearTimeout(timer);
//   }, []);

//   /* ═══════════════════════════════════════════════════════════
//      RENDER
//      ════════════════════════════════════════════════════════════ */
//   return (
//     <section className="py-10 bg-[#FAF7F2]">
//       {/* ── Section Title ──────────────────────────────────── */}
//       <div className="mb-6 text-center">
//         <h2 className="mt-2 text-[22px] font-semibold leading-tight font-rethink">
//           Public Voice{" "}
//           <span className="italic text-[#da2128]">Digital Presence</span>
//         </h2>
//       </div>

//       <div className="mx-auto px-6">
//         <div className="flex flex-col lg:flex-row gap-8 h-[520px]">
//           {/* ══════════════════════════════════════════════════
//               LEFT – PRESS (Releases / Coverage)
//               ══════════════════════════════════════════════════ */}
//           <div
//             className="lg:w-[490px] bg-[#ffffff] backdrop-blur-lg rounded-3xl p-8 shadow-sm flex flex-col h-full"
//             onMouseEnter={() => setIsPressHovering(true)}
//             onMouseLeave={() => setIsPressHovering(false)}
//           >
//             {/* Tabs */}
//             <div className="flex gap-4 mb-8 border-b pb-1">
//               <button
//                 onClick={() => setActiveTab("releases")}
//                 className={`pb-3 text-[14px] font-medium transition-all font-rethink ${
//                   activeTab === "releases"
//                     ? "text-[#da2128] border-b-2 border-[#8B0F1A]"
//                     : "text-gray-500 hover:text-[#8B0F1A]"
//                 }`}
//               >
//                 Press Releases
//               </button>
//               <button
//                 onClick={() => setActiveTab("coverage")}
//                 className={`pb-3 text-[14px] font-medium transition-all font-rethink ${
//                   activeTab === "coverage"
//                     ? "text-[#da2128] border-b-2 border-[#8B0F1A]"
//                     : "text-gray-500 hover:text-[#8B0F1A]"
//                 }`}
//               >
//                 Press Coverage
//               </button>
//             </div>

//             {/* Scrolling Timeline */}
//             <div className="relative flex-1 overflow-hidden">
//               {/* Vertical line */}
//               <div className="absolute left-6 top-0 bottom-0 w-[2px] bg-[#8B0F1A]/20"></div>

//               {/* Looping list – hover pe pause */}
//               <div
//                 className={`press-loop space-y-8 pr-4 overflow-hidden ${
//                   isPressHovering ? "paused" : ""
//                 }`}
//               >
//                 {loopedList.map((p, i) => (
//                   <div key={`${activeTab}-${i}`} className="relative pl-10">
//                     {/* Dot */}
//                     <span className="absolute left-6 top-2 -translate-x-1/2 w-3 h-3 bg-[#8B0F1A] rounded-full border-2 border-white"></span>

//                     {/* Clickable item */}
//                     <div
//                       className="group cursor-pointer"
//                       onClick={() => handleItemClick(p)}
//                       role="button"
//                       tabIndex={0}
//                       onKeyDown={(e) => {
//                         if (e.key === "Enter" || e.key === " ") {
//                           handleItemClick(p);
//                         }
//                       }}
//                     >
//                       <div className="text-[11px] text-neutral-400 mb-1.5 font-rethink">
//                         {activeTab === "releases"
//                           ? p.date
//                           : `${p.source} • ${p.date}`}
//                       </div>
//                       <h4 className="text-[14px] font-medium leading-relaxed text-neutral-800 group-hover:text-[#8B0F1A] transition font-rethink">
//                         {p.title}
//                       </h4>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* ══════════════════════════════════════════════════
//               MIDDLE – LEADERSHIP INSIGHTS
//               ══════════════════════════════════════════════════ */}
//           <div
//             className="lg:w-[500px] bg-[#ffffff] rounded-3xl shadow-xl overflow-hidden flex flex-col h-full"
//             onMouseEnter={() => setIsHovering(true)}
//             onMouseLeave={() => setIsHovering(false)}
//           >
//             {/* Header */}
//             <div className="p-6 border-b flex items-center justify-between">
//               <div>
//                 <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink">
//                   Leadership Insights
//                 </h3>
//                 <p className="text-[13px] text-gray-500">Voices of Impact</p>
//               </div>
//               <div className="flex gap-2">
//                 {LEADERSHIP_INSIGHTS.map((_, idx) => (
//                   <button
//                     key={idx}
//                     onClick={() => setCurrentIndex(idx)}
//                     className={`w-2.5 h-2.5 rounded-full transition-all ${
//                       idx === currentIndex
//                         ? "bg-[#da2128] scale-125"
//                         : "bg-gray-300"
//                     }`}
//                   />
//                 ))}
//               </div>
//             </div>

//             {/* Content */}
//             <div className="flex-1 p-3 flex flex-col">
//               <div className="flex-1 flex flex-col lg:flex-row gap-8 items-start">
//                 {/* Big Quote Mark */}
//                 <div className="text-[90px] leading-none text-[#DA2128] font-serif flex-shrink-0 -mt-8">
//                   &ldquo;
//                 </div>

//                 {/* Text + Image */}
//                 <div className="flex-1">
//                   {/* Circular Image */}
//                   <div className="flex justify-center mb-6">
//                     <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-white shadow-2xl">
//                       <img
//                         src={currentInsight.image}
//                         alt={currentInsight.name}
//                         className="w-full h-full object-cover"
//                       />
//                     </div>
//                   </div>

//                   {/* Name & Designation */}
//                   <div className="text-center mb-6">
//                     <p className="text-xl font-semibold text-neutral-900">
//                       {currentInsight.name}
//                     </p>
//                     <p className="text-[#8B0F1A] text-sm tracking-wider">
//                       {currentInsight.designation}
//                     </p>
//                   </div>

//                   {/* Quote Text */}
//                   <p className="text-[15.5px] leading-relaxed text-neutral-700 text-left">
//                     {currentInsight.text}
//                   </p>

//                   <div className="text-[#da2128] font-medium text-sm cursor-pointer hover:underline">
//                     ... Read More
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Progress Bar */}
//             <div className="h-1 bg-gray-100 mx-10 mb-6 rounded-full overflow-hidden">
//               <div
//                 className="h-full bg-[#da2128] rounded-full transition-all"
//                 style={{
//                   animation: isHovering
//                     ? "none"
//                     : "progress 8s linear infinite",
//                 }}
//               />
//             </div>
//           </div>

//           {/* ══════════════════════════════════════════════════
//               RIGHT – SOCIAL WALL
//               ══════════════════════════════════════════════════ */}
//           <div className="lg:w-[420px] bg-[#ffffff] backdrop-blur-lg border border-white/30 rounded-3xl shadow-sm p-4 flex flex-col h-full">
//             {/* Header */}
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-[#da2128]">
//                 Social Wall
//               </h3>

//               <div className="flex gap-2">
//                 {[
//                   {
//                     id: "linkedin",
//                     icon: <FaLinkedinIn />,
//                     color: "bg-blue-700",
//                   },
//                   {
//                     id: "twitter",
//                     icon: <FaXTwitter />,
//                     color: "bg-black",
//                   },
//                   {
//                     id: "facebook",
//                     icon: <FaFacebookF />,
//                     color: "bg-blue-600",
//                   },
//                   {
//                     id: "instagram",
//                     icon: <FaInstagram />,
//                     color: "bg-pink-500",
//                   },
//                 ].map((item) => (
//                   <div
//                     key={item.id}
//                     onClick={() => setActiveSocial(item.id)}
//                     className={`w-9 h-9 flex items-center justify-center rounded-xl cursor-pointer transition-all duration-300 ${
//                       activeSocial === item.id
//                         ? `${item.color} text-white shadow-lg`
//                         : "bg-white text-gray-600 hover:bg-gray-100"
//                     }`}
//                   >
//                     {item.icon}
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Social Content */}
//             <div className="flex-1 overflow-hidden rounded-2xl bg-white relative">
//               {/* Facebook */}
//               <div
//                 className={
//                   activeSocial === "facebook" ? "block h-full" : "hidden"
//                 }
//               >
//                 <iframe
//                   src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FASSOCHAM4Ind%2Fposts%2Fpfbid0RszAkkxef8VK1DhUqeHvNYSW1ohm4ThBoPfPiWg1fRN1ZCGuU3RvATuJDAEm3ZGMl&show_text=true"
//                   className="w-full h-full"
//                   style={{ border: "none" }}
//                   scrolling="no"
//                   title="Facebook Post"
//                 />
//               </div>

//               {/* Twitter / X */}
//               <div
//                 className={
//                   activeSocial === "twitter" ? "block h-full" : "hidden"
//                 }
//               >
//                 <div className="w-full h-full overflow-y-auto p-3">
//                   <blockquote className="twitter-tweet">
//                     <a href="https://twitter.com/ASSOCHAM4India/status/1410202976107450370">
//                       Tweet
//                     </a>
//                   </blockquote>
//                 </div>
//               </div>

//               {/* Instagram */}
//               <div
//                 className={
//                   activeSocial === "instagram" ? "block h-full" : "hidden"
//                 }
//               >
//                 <div className="w-full h-full overflow-y-auto p-3">
//                   <blockquote
//                     className="instagram-media"
//                     data-instgrm-permalink="https://www.instagram.com/p/DXlOfzDkTMA/"
//                     data-instgrm-version="14"
//                   />
//                 </div>
//               </div>

//               {/* LinkedIn */}
//               <div
//                 className={
//                   activeSocial === "linkedin" ? "block h-full" : "hidden"
//                 }
//               >
//                 <iframe
//                   src="https://www.linkedin.com/embed/feed/update/urn:li:share:7467553270425636864?collapsed=1"
//                   width="100%"
//                   height="700"
//                   style={{ border: 0 }}
//                   title="LinkedIn Post"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ── Animations & Styles ────────────────────────────── */}
//       <style jsx>{`
//         .press-loop {
//           animation: pressScroll 90s linear infinite;
//           will-change: transform;
//         }
//         .press-loop.paused {
//           animation-play-state: paused;
//         }
//         @keyframes pressScroll {
//           0% {
//             transform: translateY(0);
//           }
//           100% {
//             transform: translateY(-50%);
//           }
//         }
//         @keyframes progress {
//           from {
//             width: 0%;
//           }
//           to {
//             width: 100%;
//           }
//         }
//       `}</style>
//     </section>
//   );
// }




// new new code 







import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { fetchPressReleases } from "../News/pressReleaseApi.js";
import { fetchPressCoverages } from "../News/pressCoverageApi.js";
import { fetchLeadershipInsights } from "../api/leadershipInsightsApi.js";

/* ───────────────────────────────────────────────────────────
   COMPONENT
   ──────────────────────────────────────────────────────────── */
export default function MediaSocialSection() {
  // ── Tabs & Social ─────────────────────────────────────────
  const [activeTab, setActiveTab] = useState("releases");
  const [activeSocial, setActiveSocial] = useState("facebook");

  // ── Leadership Insights (ab DB se) ─────────────────────────
  const [insights, setInsights] = useState([]);
  const [insightsLoading, setInsightsLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);

  // ── Press section hover (scroll pause) ────────────────────
  const [isPressHovering, setIsPressHovering] = useState(false);

  // ── Backend data ──────────────────────────────────────────
  const [pressReleases, setPressReleases] = useState([]);
  const [pressCoverage, setPressCoverage] = useState([]);

  const navigate = useNavigate();

  /* ── Fetch 20 press releases + 20 press coverages ──────── */
  useEffect(() => {
    let alive = true;

    fetchPressReleases()
      .then((data) => {
        if (!alive) return;
        const mapped = data.slice(0, 20).map((pr) => ({
          title: pr.title,
          date: pr.displayDate,
          slug: pr.slug,
        }));
        setPressReleases(mapped);
      })
      .catch((err) => console.error("Press releases fetch failed:", err));

    fetchPressCoverages()
      .then((data) => {
        if (!alive) return;
        const mapped = data.slice(0, 20).map((pc) => ({
          title: pc.title,
          date: pc.displayDate,
          source: pc.source || "",
          externalUrl: pc.externalUrl || "",
        }));
        setPressCoverage(mapped);
      })
      .catch((err) => console.error("Press coverage fetch failed:", err));

    return () => {
      alive = false;
    };
  }, []);

  /* ── Fetch Leadership Insights ──────────────────────────── */
  useEffect(() => {
    let alive = true;

    fetchLeadershipInsights()
      .then((data) => {
        if (!alive) return;
        setInsights(data);
      })
      .catch((err) => console.error("Leadership insights fetch failed:", err))
      .finally(() => {
        if (alive) setInsightsLoading(false);
      });

    return () => {
      alive = false;
    };
  }, []);

  /* ── Active tab ke liye list ────────────────────────────── */
  const currentList =
    activeTab === "releases" ? pressReleases : pressCoverage;
  const loopedList = [
    ...currentList,
    ...currentList,
    ...currentList,
    ...currentList,
  ];

  const currentInsight = insights[currentIndex];

  /* ── Click handler ──────────────────────────────────────── */
  const handleItemClick = (item) => {
    if (activeTab === "releases") {
      if (item.slug) {
        navigate(`/press-release/${item.slug}`);
      }
    } else {
      if (item.externalUrl) {
        window.open(item.externalUrl, "_blank", "noopener,noreferrer");
      }
    }
  };

  /* ── Auto rotate Leadership Insights (hover pe rukega) ── */
  useEffect(() => {
    if (insights.length === 0) return;

    const interval = setInterval(() => {
      if (!isHovering) {
        setCurrentIndex((prev) => (prev + 1) % insights.length);
      }
    }, 8000);
    return () => clearInterval(interval);
  }, [isHovering, insights.length]);

  /* ── Social embeds sirf ek baar load karo ──────────────── */
  useEffect(() => {
    const timer = setTimeout(() => {
      if (window.twttr) window.twttr.widgets.load();
      if (window.instgrm) window.instgrm.Embeds.process();
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  /* ═══════════════════════════════════════════════════════════
     RENDER
     ════════════════════════════════════════════════════════════ */
  return (
    <section className="py-10 bg-[#FAF7F2]">
      {/* ── Section Title ──────────────────────────────────── */}
      <div className="mb-6 text-center">
        <h2 className="mt-2 text-[22px] font-semibold leading-tight font-rethink">
          Public Voice{" "}
          <span className="italic text-[#da2128]">Digital Presence</span>
        </h2>
      </div>

      <div className="mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-8 h-[520px]">
          {/* ══════════════════════════════════════════════════
              LEFT – PRESS (Releases / Coverage)
              ══════════════════════════════════════════════════ */}
          <div
            className="lg:w-[490px] bg-[#ffffff] backdrop-blur-lg rounded-3xl p-8 shadow-sm flex flex-col h-full"
            onMouseEnter={() => setIsPressHovering(true)}
            onMouseLeave={() => setIsPressHovering(false)}
          >
            {/* Tabs */}
            <div className="flex gap-4 mb-8 border-b pb-1">
              <button
                onClick={() => setActiveTab("releases")}
                className={`pb-3 text-[14px] font-medium transition-all font-rethink ${
                  activeTab === "releases"
                    ? "text-[#da2128] border-b-2 border-[#8B0F1A]"
                    : "text-gray-500 hover:text-[#8B0F1A]"
                }`}
              >
                Press Releases
              </button>
              <button
                onClick={() => setActiveTab("coverage")}
                className={`pb-3 text-[14px] font-medium transition-all font-rethink ${
                  activeTab === "coverage"
                    ? "text-[#da2128] border-b-2 border-[#8B0F1A]"
                    : "text-gray-500 hover:text-[#8B0F1A]"
                }`}
              >
                Press Coverage
              </button>
            </div>

            {/* Scrolling Timeline */}
            <div className="relative flex-1 overflow-hidden">
              {/* Vertical line */}
              <div className="absolute left-6 top-0 bottom-0 w-[2px] bg-[#8B0F1A]/20"></div>

              {/* Looping list – hover pe pause */}
              <div
                className={`press-loop space-y-8 pr-4 overflow-hidden ${
                  isPressHovering ? "paused" : ""
                }`}
              >
                {loopedList.map((p, i) => (
                  <div key={`${activeTab}-${i}`} className="relative pl-10">
                    {/* Dot */}
                    <span className="absolute left-6 top-2 -translate-x-1/2 w-3 h-3 bg-[#8B0F1A] rounded-full border-2 border-white"></span>

                    {/* Clickable item */}
                    <div
                      className="group cursor-pointer"
                      onClick={() => handleItemClick(p)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          handleItemClick(p);
                        }
                      }}
                    >
                      <div className="text-[11px] text-neutral-400 mb-1.5 font-rethink">
                        {activeTab === "releases"
                          ? p.date
                          : `${p.source} • ${p.date}`}
                      </div>
                      <h4 className="text-[14px] font-medium leading-relaxed text-neutral-800 group-hover:text-[#8B0F1A] transition font-rethink">
                        {p.title}
                      </h4>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ══════════════════════════════════════════════════
              MIDDLE – LEADERSHIP INSIGHTS
              ══════════════════════════════════════════════════ */}
          <div
            className="lg:w-[500px] bg-[#ffffff] rounded-3xl shadow-xl overflow-hidden flex flex-col h-full"
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
          >
            {/* Header */}
            <div className="p-6 border-b flex items-center justify-between">
              <div>
                <h3 className="text-[18px] font-semibold text-[#da2128] font-rethink">
                  Leadership Insights
                </h3>
                <p className="text-[13px] text-gray-500">Voices of Impact</p>
              </div>
              <div className="flex gap-2">
                {insights.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentIndex(idx)}
                    className={`w-2.5 h-2.5 rounded-full transition-all ${
                      idx === currentIndex
                        ? "bg-[#da2128] scale-125"
                        : "bg-gray-300"
                    }`}
                  />
                ))}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 p-3 flex flex-col">
              {insightsLoading && (
                <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
                  Loading...
                </div>
              )}

              {!insightsLoading && insights.length === 0 && (
                <div className="flex-1 flex items-center justify-center text-sm text-gray-400">
                  No insights found
                </div>
              )}

              {!insightsLoading && currentInsight && (
                <div className="flex-1 flex flex-col lg:flex-row gap-8 items-start">
                  {/* Big Quote Mark */}
                  <div className="text-[90px] leading-none text-[#DA2128] font-serif flex-shrink-0 -mt-8">
                    &ldquo;
                  </div>

                  {/* Text + Image */}
                  <div className="flex-1">
                    {/* Circular Image */}
                    <div className="flex justify-center mb-6">
                      <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-white shadow-2xl">
                        <img
                          src={currentInsight.image}
                          alt={currentInsight.name}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </div>

                    {/* Name & Designation */}
                    <div className="text-center mb-6">
                      <p className="text-xl font-semibold text-neutral-900">
                        {currentInsight.name}
                      </p>
                      <p className="text-[#8B0F1A] text-sm tracking-wider">
                        {currentInsight.designation}
                      </p>
                    </div>

                    {/* Quote Text */}
                    <p className="text-[15.5px] leading-relaxed text-neutral-700 text-left">
                      {currentInsight.text}
                    </p>

                    {currentInsight.link && (
                      <a
                        href={currentInsight.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block text-[#da2128] font-medium text-sm cursor-pointer hover:underline"
                      >
                        ... Read More
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Progress Bar */}
            <div className="h-1 bg-gray-100 mx-10 mb-6 rounded-full overflow-hidden">
              <div
                className="h-full bg-[#da2128] rounded-full transition-all"
                style={{
                  animation: isHovering
                    ? "none"
                    : "progress 8s linear infinite",
                }}
              />
            </div>
          </div>

          {/* ══════════════════════════════════════════════════
              RIGHT – SOCIAL WALL
              ══════════════════════════════════════════════════ */}
          <div className="lg:w-[420px] bg-[#ffffff] backdrop-blur-lg border border-white/30 rounded-3xl shadow-sm p-4 flex flex-col h-full">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-[#da2128]">
                Social Wall
              </h3>

              <div className="flex gap-2">
                {[
                  {
                    id: "linkedin",
                    icon: <FaLinkedinIn />,
                    color: "bg-blue-700",
                  },
                  {
                    id: "twitter",
                    icon: <FaXTwitter />,
                    color: "bg-black",
                  },
                  {
                    id: "facebook",
                    icon: <FaFacebookF />,
                    color: "bg-blue-600",
                  },
                  {
                    id: "instagram",
                    icon: <FaInstagram />,
                    color: "bg-pink-500",
                  },
                ].map((item) => (
                  <div
                    key={item.id}
                    onClick={() => setActiveSocial(item.id)}
                    className={`w-9 h-9 flex items-center justify-center rounded-xl cursor-pointer transition-all duration-300 ${
                      activeSocial === item.id
                        ? `${item.color} text-white shadow-lg`
                        : "bg-white text-gray-600 hover:bg-gray-100"
                    }`}
                  >
                    {item.icon}
                  </div>
                ))}
              </div>
            </div>

            {/* Social Content */}
            <div className="flex-1 overflow-hidden rounded-2xl bg-white relative">
              {/* Facebook */}
              <div
                className={
                  activeSocial === "facebook" ? "block h-full" : "hidden"
                }
              >
                <iframe
                  src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FASSOCHAM4Ind%2Fposts%2Fpfbid0RszAkkxef8VK1DhUqeHvNYSW1ohm4ThBoPfPiWg1fRN1ZCGuU3RvATuJDAEm3ZGMl&show_text=true"
                  className="w-full h-full"
                  style={{ border: "none" }}
                  scrolling="no"
                  title="Facebook Post"
                />
              </div>

              {/* Twitter / X */}
              <div
                className={
                  activeSocial === "twitter" ? "block h-full" : "hidden"
                }
              >
                <div className="w-full h-full overflow-y-auto p-3">
                  <blockquote className="twitter-tweet">
                    <a href="https://twitter.com/ASSOCHAM4India/status/1410202976107450370">
                      Tweet
                    </a>
                  </blockquote>
                </div>
              </div>

              {/* Instagram */}
              <div
                className={
                  activeSocial === "instagram" ? "block h-full" : "hidden"
                }
              >
                <div className="w-full h-full overflow-y-auto p-3">
                  <blockquote
                    className="instagram-media"
                    data-instgrm-permalink="https://www.instagram.com/p/DXlOfzDkTMA/"
                    data-instgrm-version="14"
                  />
                </div>
              </div>

              {/* LinkedIn */}
              <div
                className={
                  activeSocial === "linkedin" ? "block h-full" : "hidden"
                }
              >
                <iframe
                  src="https://www.linkedin.com/embed/feed/update/urn:li:share:7467553270425636864?collapsed=1"
                  width="100%"
                  height="700"
                  style={{ border: 0 }}
                  title="LinkedIn Post"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Animations & Styles ────────────────────────────── */}
      <style jsx>{`
        .press-loop {
          animation: pressScroll 90s linear infinite;
          will-change: transform;
        }
        .press-loop.paused {
          animation-play-state: paused;
        }
        @keyframes pressScroll {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(-50%);
          }
        }
        @keyframes progress {
          from {
            width: 0%;
          }
          to {
            width: 100%;
          }
        }
      `}</style>
    </section>
  );
}